export const NavigationMenu = [
    {
        label: 'Home',
        icon: require('@/assets/nav/home.svg'),
        routerPath: '/oms/home',
        permission_id: 0,
        isSpecial: true
    },
    {
        label: 'Overview',
        icon: require('@/assets/nav/overview.svg'),
        routerPath: '/oms/overview',
        permission_id: 32,
        isSpecial: true
    },
    {
        label: 'Customer',
        icon: require('@/assets/nav/customer.svg'),
        routerPath: '/oms/leadpool/leadpoolmain',
        permission_id: 1,
        subMenu: [
            {
                label: 'All Customer',
                routerPath: '/oms/customer/allCustomer',
                permission_id: 2
            },
            {
                label: 'Lead Pool',
                routerPath: '/oms/leadpool/leadpoolmain',
                permission_id: 2
                // subMenu: [
                //     {
                //         label: 'sub-menu-1',
                //         routerPath: '/oms/leadpool/leadpoolmain-1',
                //         permission_id: '3'
                //     },
                //     {
                //         label: 'sub-menu-2',
                //         routerPath: '/oms/leadpool/leadpoolmain-2',
                //         permission_id: '212'
                //     },
                //     {
                //         label: 'sub-menu-3',
                //         routerPath: '/oms/leadpool/leadpoolmain-3',
                //         permission_id: '213',
                //         subMenu: [
                //             {
                //                 label: 'sub-menu-1-1',
                //                 routerPath: '/oms/leadpool/leadpoolmain-1-1',
                //                 permission_id: '2131'
                //             },
                //             {
                //                 label: 'sub-menu-2-2',
                //                 routerPath: '/oms/leadpool/leadpoolmain-1-2',
                //                 permission_id: '2132'
                //             }
                //         ]
                //     }
                // ]
            },
            {
                label: 'Confirm Customer',
                routerPath: '/oms/customer/confirmCustomer',
                permission_id: 3
            },
            {
                label: 'Approve Customer',
                routerPath: '/oms/customer/approveCustomer',
                permission_id: 4
            },
            {
                label: 'Customer',
                routerPath: '/oms/customer/customerList',
                permission_id: 5
            }
        ]
    },
    {
        label: 'Order',
        icon: require('@/assets/nav/basket.svg'),
        routerPath: '/oms/OrderSearch/OrderManage',
        permission_id: 6,
        subMenu: [
            {
                label: 'Order Manage',
                routerPath: '/oms/OrderSearch/OrderManage',
                permission_id: 7
            },
            {
                label: 'Export Order Excel',
                routerPath: '/oms/exportOrder',
                permission_id: 8
            },
            {
                label: 'Export SCG Status',
                routerPath: '/oms/exportScgStatus',
                permission_id: 9
            },
            {
                label: 'Log Order',
                routerPath: '/oms/logOrder/logOrderSearch',
                permission_id: 10
            },
            {
                label: 'Log Create Shipment',
                routerPath: '/oms/logOrder/LogCreateShipment',
                permission_id: 11
            },
            {
                label: 'Edited Order Log',
                routerPath: '/oms/logOrder/EditedOrder',
                permission_id: 12
            },
            {
                label: 'Mobile Order Log',
                routerPath: '/oms/logOrder/mobileOrder',
                permission_id: 13
            },
            {
                label: 'KP Upload Excel',
                routerPath: '/oms/logOrder/kpOrderUpload',
                permission_id: 14
            }
        ]
    },
    {
        label: 'Shipment',
        icon: require('@/assets/nav/shipping.svg'),
        routerPath: '/oms/courier/notify',
        permission_id: 15,
        subMenu: [
            {
                label: 'Notify Courier FLASH',
                routerPath: '/oms/courier/notify',
                permission_id: 16
            },
            {
                label: 'Booking Courier SCG',
                routerPath: '/oms/courier/NotifyCourierSCG',
                permission_id: 17
            },
            {
                label: 'Thaipost EMS - Tracking',
                routerPath: '/oms/courier/thaipost-ems',
                permission_id: 18
            }
            // {
            //     label: 'Courier Best',
            //     routerPath: '/oms/courier/best',
            //     permission_id: '44'
            // },
            // {
            //     label: 'Courier Thaipost EMS',
            //     routerPath: '/oms/courier/thaipost-ems',
            //     permission_id: '45'
            // }
        ]
    },
    {
        label: 'Finance',
        icon: require('@/assets/nav/finance.svg'),
        routerPath: '/oms/payment/list',
        permission_id: 19,
        subMenu: [
            {
                label: 'Payment Generate',
                routerPath: '/oms/payment/list',
                permission_id: 20
            },
            {
                label: 'Invoice Generate',
                routerPath: '/oms/invoice/InvoiceList',
                permission_id: 21
            }
        ]
    },
    {
        label: 'Configuration',
        icon: require('@/assets/nav/config.svg'),
        routerPath: '/oms/courier/manage',
        permission_id: 22,
        subMenu: [
            {
                label: 'Manage Courier',
                routerPath: '/oms/courier/manage',
                permission_id: 23
            },
            {
                label: 'Available Zipcode SCG',
                routerPath: '/oms/courier/AvailableZipcodeSCG',
                permission_id: 24
            },
            {
                label: 'Except Zipcode Scg',
                routerPath: '/oms/courier/ExceptZipcodeScg',
                permission_id: 25
            },
            {
                label: 'Sorting Code Courier',
                routerPath: '/oms/courier/sorting-code',
                permission_id: 26
            },
            {
                label: 'Version Program Fillgoods',
                routerPath: '/oms/version',
                permission_id: 27
            },
            {
                label: 'Facebook Live Status Connection',
                routerPath: '/oms/FacebookLiveConnection',
                permission_id: 28
            },
            {
                label: 'Zipcode System',
                routerPath: '/oms/OrderSearch/ZipcodeSystem',
                permission_id: 29
            },
            {
                label: 'Role Management',
                routerPath: '/oms/role-management',
                permission_id: 30
            },
            {
                label: 'User Management',
                routerPath: '/oms/user-management',
                permission_id: 31
            }

            // {
            //     label: 'Manual',
            //     routerPath: '/oms/manual'
            // }
        ]
    }
    // Case: {
    //     label: 'Case',
    //     icon: require('@/assets/nav/file.svg'),
    //     subMenu: [
    //         {
    //             label: 'CaseOrder',
    //             routerPath: '/oms/Case/CaseOrder'
    //         },
    //         {
    //             label: 'GenerateNotify',
    //             routerPath: '/oms/Case/GenerateNotify'
    //         },
    //         {
    //             label: 'CsPerformance',
    //             routerPath: '/oms/Case/CsPerformance'
    //         },
    //         {
    //             label: 'CustomerCs',
    //             routerPath: '/oms/Case/CustomerCs'
    //         },
    //         {
    //             label: 'CsProfile',
    //             routerPath: '/oms/Case/CsProfile'
    //         }
    //     ]
    // }
    // {
    //     label: 'LogOrder',
    //     icon: 'el-icon-s-order',
    //     subMenu: [
    //         {
    //             label: 'Export SCG Status',
    //             routerPath: '/oms/exportScgStatus'
    //         },
    //         {
    //             label: 'Log Order',
    //             routerPath: '/oms/logOrder/logOrderSearch'
    //         },
    //         {
    //             label: 'Log Create Shipment',
    //             routerPath: '/oms/logOrder/LogCreateShipment'
    //         },
    //         {
    //             label: 'Edited Order',
    //             routerPath: '/oms/logOrder/EditedOrder'
    //         },
    //         {
    //             label: 'Mobile Order',
    //             routerPath: '/oms/logOrder/mobileOrder'
    //         },
    //         {
    //             label: 'KP Upload order',
    //             routerPath: '/oms/logOrder/kpOrderUpload'
    //         }
    //     ]
    // },
    // {
    //     label: 'Dashboard',
    //     icon: 'el-icon-data-board',
    //     routerPath: '/oms/dashboard'
    // },
    // {
    //     label: ' CMS',
    //     icon: 'fas fa-file-signature',
    //     routerPath: '/oms/cms'
    // },
    // {
    //     label: 'Case',
    //     icon: 'el-icon-document',
    //     subMenu: [
    //         {
    //             label: 'CaseOrder',
    //             routerPath: '/oms/Case/CaseOrder'
    //         },
    //         {
    //             label: 'GenerateNotify',
    //             routerPath: '/oms/Case/GenerateNotify'
    //         },
    //         {
    //             label: 'CsPerformance',
    //             routerPath: '/oms/Case/CsPerformance'
    //         },
    //         {
    //             label: 'CustomerCs',
    //             routerPath: '/oms/Case/CustomerCs'
    //         },
    //         {
    //             label: 'CsProfile',
    //             routerPath: '/oms/Case/CsProfile'
    //         }
    //     ]
    // },
]
